import { apiClient } from '@/api/client'
import type { AlarmTopic, AlarmTopicFormFields, AlarmTopicsResponse } from './types'

export async function fetchAlarmTopics(): Promise<AlarmTopicsResponse> {
  const { data } = await apiClient.get<AlarmTopicsResponse>('/portal/settings/alarm-topics')
  return data
}

export async function createAlarmTopic(fields: AlarmTopicFormFields): Promise<AlarmTopic> {
  const { data } = await apiClient.post<{ alarm_topic: AlarmTopic }>(
    '/portal/settings/alarm-topics/create',
    fields,
  )
  return data.alarm_topic
}

export async function updateAlarmTopic(id: number, fields: AlarmTopicFormFields): Promise<AlarmTopic> {
  const { data } = await apiClient.post<{ alarm_topic: AlarmTopic }>(
    `/portal/settings/alarm-topics/${id}/update`,
    fields,
  )
  return data.alarm_topic
}

export async function deleteAlarmTopic(id: number): Promise<void> {
  await apiClient.post(`/portal/settings/alarm-topics/${id}/delete?confirm=true`)
}
